import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexHoverGallery',
  setup(__props) {

const HoverEffect1 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect1.vue"))
const HoverEffect2 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect2.vue"))
const HoverEffect3 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect3.vue"))
const HoverEffect4 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect4.vue"))
const HoverEffect5 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect5.vue"))
const HoverEffect6 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect6.vue"))
const HoverEffect7 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect7.vue"))
const HoverEffect8 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect8.vue"))
const HoverEffect9 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect9.vue"))
const HoverEffect10 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect10.vue"))
const HoverEffect11 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect11.vue"))
const HoverEffect12 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect12.vue"))
const HoverEffect13 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect13.vue"))
const HoverEffect14 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect14.vue"))
const HoverEffect15 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/HoverEffect15.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Gallery",
      mains: "Gallery",
      title: "Gallery"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(HoverEffect1)),
      _createVNode(_unref(HoverEffect2)),
      _createVNode(_unref(HoverEffect3)),
      _createVNode(_unref(HoverEffect4)),
      _createVNode(_unref(HoverEffect5)),
      _createVNode(_unref(HoverEffect6)),
      _createVNode(_unref(HoverEffect7)),
      _createVNode(_unref(HoverEffect8)),
      _createVNode(_unref(HoverEffect9)),
      _createVNode(_unref(HoverEffect10)),
      _createVNode(_unref(HoverEffect11)),
      _createVNode(_unref(HoverEffect12)),
      _createVNode(_unref(HoverEffect13)),
      _createVNode(_unref(HoverEffect14)),
      _createVNode(_unref(HoverEffect15))
    ])
  ], 64))
}
}

})